module.exports = __webpack_public_path__ + "img/blue_squares.4779dffb.png";